import { Pipe, PipeTransform } from "@angular/core";
import { Iso639_1, Language } from "../../_model/Language";
import { PHBGlobals } from "../../_config/config";

@Pipe({
	name: "languageByIsoCode",
	standalone: true
})
export class LanguageByIsoCodePipe implements PipeTransform {

	transform(isoCode: Iso639_1): Language {
		return PHBGlobals.languages[isoCode.split('_')[0]];
	}

}
